import validate from "/frontend/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.4.1_@types+node@25.0.3_db0@0.3.1_eslint@9.34.0_jiti@2.6.1_3de35219f66c5c759f7a3a4948af7cfa/node_modules/nuxt/dist/pages/runtime/validate.js";
import authentication_45global from "/frontend/middleware/authentication.global.ts";
import authorization_45global from "/frontend/middleware/authorization.global.ts";
import manifest_45route_45rule from "/frontend/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.4.1_@types+node@25.0.3_db0@0.3.1_eslint@9.34.0_jiti@2.6.1_3de35219f66c5c759f7a3a4948af7cfa/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  authentication_45global,
  authorization_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}